export default __webpack_public_path__ + "static/media/Male.ebf2a6e8.svg";